/**
 * @file token-helper.ts
 * @description Утилиты для управления токенами аутентификации в Task Manager приложении. Обеспечивает сохранение, получение и валидацию JWT токенов в localStorage.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies []
 * @related-files ['src/features/auth/auth-slice.ts', 'src/api/config.ts', 'src/routes/private-route.tsx']
 */

/**
 * Сохраняет токен доступа и время его истечения в localStorage
 * @param token - токен доступа для сохранения
 * @param expiresAt - время истечения токена в формате строки
 */
export const setToken = (token: string, expiresAt: string) => {
    localStorage.setItem(`${import.meta.env.VITE_BASE_URL}_accessToken`, token);
    localStorage.setItem(`${import.meta.env.VITE_BASE_URL}_accessTokenExpiresAt`, expiresAt);
};

/**
 * Получает токен доступа из localStorage с проверкой времени истечения
 * @returns строка токена или null, если токен отсутствует или истек
 */
export const getToken = () => {
    const token = localStorage.getItem(`${import.meta.env.VITE_BASE_URL}_accessToken`);
    if (!token) {
        console.log('!token');
        return null;
    }

    const expiresAt = localStorage.getItem(`${import.meta.env.VITE_BASE_URL}_accessTokenExpiresAt`);

    if (!expiresAt || new Date() > new Date(expiresAt)) {
        console.log('remove item token-helper');
        localStorage.removeItem(`${import.meta.env.VITE_BASE_URL}_accessToken`);
        localStorage.removeItem(`${import.meta.env.VITE_BASE_URL}_accessTokenExpiresAt`);

        return null;
    }

    return token;
};
